module.exports = __webpack_public_path__ + "img/QRCodeFR.ed29d3e2.png";